'use strict';

var lang = require('../lang'),
    actions = require('./actions');


module.exports = {
    get: function ( direction, callback ) {
        lang.currentProvider = this;
        callback(false, [
            [
                '1', '2', '3',
                {className: 'backspace', action: actions.backspace}
            ],
            [
                '4', '5', '6',
                {value: gettext('Clear'), action: actions.clear}
            ],
            [
                '7', '8', '9',
                {value: gettext('Enter'), action: actions.done, className: 'yellowText'}
            ],
            [
                {value: 'ABC', action: actions.qwertyKeyboard},
                '0', '.',
                {value: gettext('Cancel'), action: actions.cancel, className: 'cancel'}
            ]
        ]);
    }
};
